export function getBaseLocation() {
    let registerRoute = ['/home','/signup', '/products/[a-zA-Z0-9]', '/product/[a-zA-Z0-9]', '/product-detail/[a-zA-Z0-9]', '/application','/join',
        '/pages/[A-Za-z]', '/complete', '/main','/checkout','/orderhistory', '/manageautoship', '/autoorderhistory', '/complete', '/404', '/order-success', '/signup', '/orderinvoice', '/forgotpassword', 'shipping', '/membership'];
    if (registerRoute.includes(location.pathname)) {
        return '/www';
    }
    if (location.pathname.includes('pages/') && location.pathname.includes('checkout/')) {
        let routeMatch = registerRoute.some((item) => {
            return new RegExp(item).test(location.pathname);
        });
        if (routeMatch) {
            return '/www';
        }
    }
    let paths: string[] = location.pathname.split('/').splice(1, 1);

    let afterpaths:string[] = location.pathname.split('/').splice(2,1);

    let afterpath:string = ( afterpaths[0]);
    let basePath: string = (paths && paths[0]) || 'www';
    return '/' + basePath;
}

export function getafterLocation() {
  let registerRoute = ['/home','/signup', '/products/[a-zA-Z0-9]', '/product/[a-zA-Z0-9]', '/product-detail/[a-zA-Z0-9]', '/application','/join',
      '/pages/[A-Za-z]', '/complete', '/main','/checkout','/orderhistory', '/manageautoship', '/autoorderhistory', '/complete', '/404', '/order-success', '/signup', '/orderinvoice', '/forgotpassword', 'shipping', '/membership'];
  if (registerRoute.includes(location.pathname)) {
      return '/www';
  }
  if (location.pathname.includes('pages/') && location.pathname.includes('checkout/')) {
      let routeMatch = registerRoute.some((item) => {
          return new RegExp(item).test(location.pathname);
      });
      if (routeMatch) {
          return '/www';
      }
  }
  let paths: string[] = location.pathname.split('/').splice(1, 1);

  let afterpaths:string[] = location.pathname.split('/').splice(2,1);

  let afterpath:string = ( afterpaths[0]);
  // Handle the case where afterpath is undefined (root path)
  if (!afterpath || afterpath === '') {
      return '/www';
  }
  return '/' + afterpath;
}

/**
 * Determines the API URL based on the current site URL
 * If running on localhost or site URL includes 'stage', returns the stage API URL
 * Otherwise, returns the production API URL
 */
export function getDynamicApiUrl(): string {
  if (typeof window !== 'undefined' && window.location) {
    const currentUrl = window.location.href.toLowerCase();
    const hostname = window.location.hostname.toLowerCase();
    
    // Use stage API for localhost or if URL contains 'stage'
    if (hostname === 'localhost' || hostname === '127.0.0.1' || currentUrl.includes('stage')) {
      return 'https://stage-tangerinefun-api.webhublink.com/';
    }
  }
  return 'https://tangerinefun-api.webhublink.com/';
}